import { type PropsWithChildren } from 'react';

import styles from './Loader.module.css';

const MAX_PROGRESS_BARS = 3;

interface Props {
  message?: string;
  progress?: [key: string, value: number | undefined][];
}

function Loader(props: PropsWithChildren<Props>) {
  const { message = 'Loading...', progress = [], children } = props;

  return (
    <div className={styles.loader}>
      <div className={styles.grid}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      {progress.length > 0 && (
        <div className={styles.progressBars}>
          {progress.slice(0, MAX_PROGRESS_BARS).map(([key, val]) => (
            <progress className={styles.progress} key={key} value={val} />
          ))}
        </div>
      )}
      <p>{message}</p>
      {children}
    </div>
  );
}

export default Loader;
